// extracted by mini-css-extract-plugin
module.exports = {"buttonExitWrapper":"ExitButton_buttonExitWrapper__E1qik","buttonExitText":"ExitButton_buttonExitText__BJpnp"};